"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAmplitudeInstance = exports.sendCPLog = exports.initCPLog = void 0;
var hackle_1 = require("./hackle");
var amplitude_1 = require("./amplitude");
var flounder_1 = require("./flounder");
var events_1 = require("./events");
var utm_1 = require("./utm");
var gtm_1 = require("./gtm");
var flounderInstance;
var amplitudeInstance;
var hackleInstance;
var initCPLog = function (flounder_key, amplitude_key, hackle_key, is_dev, amplitude_browser_options) {
    if (is_dev === void 0) { is_dev = true; }
    flounderInstance = new flounder_1.FlounderLog(flounder_key, is_dev);
    if (amplitude_browser_options) {
        amplitudeInstance = new amplitude_1.AmplitudeLog(amplitude_key, amplitude_browser_options);
    }
    else {
        amplitudeInstance = new amplitude_1.AmplitudeLog(amplitude_key, {
            autocapture: {
                attribution: {
                    resetSessionOnNewCampaign: true,
                },
            },
        });
    }
    hackleInstance = new hackle_1.HackleLog(hackle_key);
    (0, utm_1.setUTMCookies)();
    (0, utm_1.setGclidCookie)();
};
exports.initCPLog = initCPLog;
var pageUnloading = false;
if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', function () { pageUnloading = true; });
    window.addEventListener('load', function () { pageUnloading = false; });
}
var sendCPLog = function (key, data, is_gtm) {
    if (data === void 0) { data = {}; }
    if (is_gtm === void 0) { is_gtm = false; }
    try {
        var customData = new events_1.CustomData();
        var mergedData = __assign(__assign({}, customData), data);
        var nestedData_1 = __assign(__assign({}, customData), { data: data });
        amplitudeInstance.send(key, mergedData);
        hackleInstance.send(key, mergedData);
        if (is_gtm) {
            (0, gtm_1.sendGTM)(key, mergedData);
        }
        // Use setTimeout to defer the execution of this block
        setTimeout(function () {
            if (pageUnloading) {
                amplitudeInstance.useSendBeacon();
                flounderInstance.send_events_keep_alive(key, nestedData_1);
            }
            if (!pageUnloading) {
                flounderInstance.push_events(key, nestedData_1);
            }
        }, 0);
    }
    catch (e) {
        console.log(e);
    }
};
exports.sendCPLog = sendCPLog;
var getAmplitudeInstance = function () {
    return amplitudeInstance.getInstance();
};
exports.getAmplitudeInstance = getAmplitudeInstance;
// export const sendCPLog = (key: string, data = {}) => {
//   try {
//     setUTMCookies();
//     setGclidCookie();
//     Object.assign(data, new CustomData())
//     flounderInstance.push_events(key, data);
//     amplitudeInstance.send(key, data);
//     hackleInstance.send(key, data);
//   } catch (e) {
//     console.log(e)
//   }
// }
//# sourceMappingURL=index.js.map